import React from 'react';
import { FormProps } from 'util/Form';
import EmailFormItem from 'components/profile/EmailFormItem';

interface EmailQuestionFormItemProps extends FormProps {
  fieldName: string;
  required?: boolean;
}

const EmailQuestionFormItem: React.FunctionComponent<EmailQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
}) => {
  return <EmailFormItem fieldName={fieldName} label="" required={required} disabled={disabled} />;
};
export default EmailQuestionFormItem;
